import { socialLinks } from '../../data/siteContent';
import logo from '../../logo.svg';

function SiteFooter({ variant = 'default' }) {
  const footerClassName = variant === 'intro' ? 'site-footer site-footer--intro' : 'site-footer';

  return (
    <footer className={footerClassName}>
      <div className="site-footer__inner">
        <div className="footer-brand-block">
          <div className="footer-brand" aria-label="말타">
            <img src={logo} alt="" />
            <span>Marlta</span>
          </div>
          <div className="footer-company">
            <span>(주)럭스포 LUXSPO</span>
            <span>0507-1325-0543</span>
            <a href="mailto:help@luxspo.com">help@luxspo.com</a>
          </div>
        </div>

        <div className="footer-link-columns">
          <div className="footer-link-column">
            <strong>소셜</strong>
            <div className="footer-social-row">
              {socialLinks.map((item) => (
                <a
                  className="footer-social-link"
                  href={item.href}
                  key={item.label}
                  rel="noreferrer"
                  target="_blank"
                  title={item.label}
                >
                  <img src={item.icon} alt="" aria-hidden="true" />
                  <span>{item.label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
